const prepareNumber = (num) => {
  const number = num && Number(num)
  return number && (Number.isInteger(number) ? parseInt(number).toLocaleString() : number)
}

export default {
  prepareField({ cfs, fieldId, preparing = true, fieldsConfig }) {
    const field = cfs.find(cf => Number(cf.field_id) === Number(fieldId))
    if (!field) {
      return { value: null }
    }

    const { field_name: name, field_type: fieldType, values } = field
    
    const firstValue = values[0].value
    let preparedValue
    // todo сделать даты
    switch (fieldType) {
      case 'numeric':
        preparedValue = preparing ? prepareNumber(firstValue) : firstValue
        break
      case 'multiselect':
        preparedValue = preparing ? values.map(e => e.value).join(', ') : values
        break
      default:
        preparedValue = firstValue
        break
    }

    const measures = fieldsConfig?.measures || []
    const candidateMeasure = measures.find(m => m.fieldId === fieldId) || {}
    const measure = candidateMeasure.type === 'valute' ? '₽' : candidateMeasure.measure

    return {
      name,
      value: preparedValue,
      measure: measure || '',
    } 
  },
  divideTwoFields(cfs, firstId, secondId, fieldsConfig) {
    let { value: firstValue, measure: firstMeasure } = this.prepareField({ cfs, fieldId: firstId, preparing: false, fieldsConfig })
    let { value: secondValue, measure: secondMeasure } = this.prepareField({ cfs, fieldId: secondId, preparing: false, fieldsConfig })

    return firstValue && secondValue && `${prepareNumber(parseInt(firstValue / secondValue))} ${firstMeasure}/ ${secondMeasure}`
  },
  imagesUrls(images, imagesHost, leadId) {
    return images.map(i => i.includes('http') ? i : `${imagesHost}${leadId}/${i}`)
  },
}